import { render, staticRenderFns } from "./ReferralList.vue?vue&type=template&id=6f7078fc&scoped=true&"
import script from "./ReferralList.vue?vue&type=script&lang=js&"
export * from "./ReferralList.vue?vue&type=script&lang=js&"
import style0 from "./ReferralList.vue?vue&type=style&index=0&id=6f7078fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7078fc",
  null
  
)

export default component.exports